
























































































































import mixins from 'vue-typed-mixins'
import CallMixin from '@/mixins/CallMixin'
import UserActionMixin from '@/mixins/UserActionMixin'
import MediaModalMixin from '@/mixins/MediaModalMixin'
import Profile from '@/components/Profile.vue'
import PullRefresh from '@/components/PullRefresh.vue'
import TimelineMedia from '@/components/TimelineMedia.vue'
import { mapMutations, mapGetters } from 'vuex'
import * as _ from 'lodash'
import { loadImage } from '@/utils/ImageUtil'
import { sleep } from '../utils/helpers'

export default mixins(CallMixin, MediaModalMixin, UserActionMixin).extend({
  name: 'user',
  components: {
    Profile,
    PullRefresh,
    TimelineMedia
  },
  props: {
    overlayPageModal: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      fav: false,
      favTimer: null,
      profile: this.$route.params.profile || {},
      tweets: this.$route.params.tweets || {},
      unreadCount: 0,
      keys: [],
      currentKey: 0,
      currentKeys: [],
      currentId: '',
      disabledPrevUserButton: false,
      disabledNextUserButton: false,
      isRefreshing: false,
      isInitialized: false,
      initialized: false,
      savePhotoPoint: ''
    }
  },
  computed: {
    ...mapGetters('TopUser', [
      'currentEntryKey',
      'currentEntryKeys',
      'entries',
      'gridEntries',
      'topViewStyle'
    ]),
    ...mapGetters('User', ['currentData']),
    ...mapGetters('MyData', ['myGender']),

    /**
     * プロフ画像を lazy load させるかどうか
     */
    isLazyProfileImage(): boolean {
      return !/(home|search\/name)/.test(this.$store.getters.fromName)
    },

    /**
     * トップのスタイル
     */
    isTopGridStyle(): boolean {
      return this.topViewStyle === 'grid'
    },

    /**
     * トップのスタイル
     */
    isTopListStyle(): boolean {
      return this.topViewStyle === 'list'
    },

    /**
     * ページスワイプボタンを表示するか
     */
    isVisiblePageSwipeButtons(): boolean {
      const fromName = this.$store.getters['fromName']
      const hasEntries =
        (this.isTopGridStyle && this.gridEntries.length && this.gridEntries[0].length > 1) ||
        (this.isTopListStyle && this.entries.length > 1)
      return (
        hasEntries &&
        fromName &&
        fromName !== 'search' &&
        (/(home|timeline)/.test(fromName) ||
          /(home|timeline)/.test(this.$store.getters['currentBasePageName']))
      )
    },

    /**
     * お気に入りボタンのラベル
     */
    favLabel(): string {
      return this.profile['fav'] ? 'お気に入りを解除' : 'お気に入りに追加'
    }
  },
  watch: {
    overlayPageModal(val: boolean) {
      // ユーザープロフダイアログが閉じられたら MediaModal も閉じる
      if (!val && this.$_modal) {
        this.$_closeMediaModal()
      }
    },

    async props(val) {
      if (val) {
        // モーダルで開かれた
        // 最初に props が undefined の状態で User が開かれ値がおかしくなっているものをリセットする
        this.disabledPrevUserButton = false
        this.disabledNextUserButton = false

        if (this.isVisiblePageSwipeButtons) {
          this.unreadCount = parseInt(val.unreadCount, 10)

          this.mightDisabledPageSwipeButtons()
        }
        this.profile = val.profile
        this.currentId = val.id
        // あしあとのカウントアップとファイル保存ポイントの取得
        const data = await this.$_fetchProfile(this.currentId)
        data.id = this.currentId
        this.tweets = data.tweets
        this.savePhotoPoint = data.profile.save_img_pt
        this.setCurrentData(data)
      }
    },

    tweets(val) {
      // tweets には 'name' と 'user_id' が含まれないので付与する
      // tweets の watch なのでこ要素を変更しても無限ループにはならない
      const keys = Object.keys(val)
      if (val && keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          val[keys[i]]['name'] = this.profile['name']
          val[keys[i]]['user_id'] = this.currentId
        }
      }
    }
  },
  async beforeRouteEnter(to, from, next) {
    // preload
    const imageUrlL = to.params['profile'] ? to.params.profile['image_url_l'] : null
    if (imageUrlL) {
      loadImage({ src: imageUrlL })
    }

    next(async (vm: any) => {
      const paramsId = from.params.id
        ? from.params.id
        : from.params.user_id
        ? from.params.user_id
        : ''
      // ID で同じユーザならキャッシュを利用する
      if (
        /(call|chat|timeline|timeline\/detail)/.test(from.name) &&
        paramsId &&
        vm.currentData.id &&
        paramsId === vm.currentData.id
      ) {
        vm.profile = vm.currentData.profile
        vm.tweets = vm.currentData.tweets
      }
      await vm.fetchData()
    })
  },
  created() {
    // プロフページで表示ユーザの切り替え
    if (this.isVisiblePageSwipeButtons) {
      this.unreadCount = parseInt(this.$route.params.unread_count, 10)

      this.mightDisabledPageSwipeButtons()
    }
    if (this.$route.params.profile) {
      this.profile = this.$route.params.profile
      this.savePhotoPoint = this.profile['save_img_pt']
      this.unreadCount = parseInt(this.$route.params.unread_count, 10)
    }
    this.currentId = this.$route.params.id
  },
  async mounted() {
    await this.$nextTick()
    await sleep(1000)
    this.initialized = true
  },
  methods: {
    ...mapMutations('TopUser', ['setEntry', 'setGridEntry']),
    ...mapMutations('User', ['setCurrentData']),

    /**
     * fetch data
     */
    async fetchData() {
      const userId = this.$route.params.id || location.href.split('/').splice(-1)[0]
      const data = await this.$_fetchProfile(userId)
      data.id = userId
      if (data.profile) {
        this.profile = data.profile
        this.tweets = data.tweets
        this.unreadCount = data.unread_count
        if (this.profile && typeof this.profile['fav'] === 'string') {
          this.profile['fav'] = Boolean(this.profile['fav'])
        }

        this.savePhotoPoint = this.profile['save_img_pt']
        this.setCurrentData(data)
      }
    },

    /**
     * 表示しているユーザによってページスワイプボタンの無効化
     */
    mightDisabledPageSwipeButtons() {
      if (this.isTopGridStyle) {
        this.keys = Object.keys(this.gridEntries)
        this.currentKey = this.currentEntryKey
        this.currentKeys = this.currentEntryKeys
        if (this.currentKeys[0] === 0 && this.currentKeys[1] === 0) {
          this.disabledPrevUserButton = true
        } else if (this.currentKeys[0] === this.keys.length - 1 && this.currentKeys[1] === 1) {
          this.disabledNextUserButton = true
        }
      } else {
        this.keys = Object.keys(this.entries)
        this.currentKey = this.currentEntryKey
        if (this.currentKey === 0) {
          this.disabledPrevUserButton = true
        } else if (this.currentKey === this.keys.length - 1) {
          this.disabledNextUserButton = true
        }
      }
    },

    /**
     * お気に入りをトグル
     */
    async toggleFavorite(this: any) {
      if (this.favTimer) {
        return
      }
      try {
        const fav = await this.$_toggleFavorite(this.currentId)
        this.$set(this.profile, 'fav', fav)
        if (!fav || this.myGender === '2') {
          return
        }
      } catch (err) {
        console.error(err)
      }

      this._favTimer = setTimeout(async () => {
        const message = `お気に入りに ${this.profile.name} さんを追加しました。 ${
          this.profile.name
        } さんにギフトを贈りますか？`
        const buttonIndex = await this.$_confirm(message, '', ['キャンセル', 'ギフトを贈る'])
        clearTimeout(this._favTimer)
        this._favTimer = null
        if (!this.$_clickedConfirmOK(buttonIndex)) {
          return
        }
        this.$router.push({ name: 'gift', params: { id: this.currentId } })
      })
    },

    /**
     * チャットページにジャンプ
     */
    jumpToChat(this: any) {
      this.$store.commit('Chat/setName', this.profile.name)
      this.$store.commit('Chat/setImageUrl', this.profile.image_url)
      const params = { id: this.currentId }
      if (this.props) {
        params['backUrl'] = this.props.backUrl
      }
      this.$router.push({
        name: 'chat',
        params: params
      })
    },

    /**
     * タイムライン一覧にジャンプ
     */
    async jumpToTimeline() {
      // type===3 の状態でジャンプすると何も表示されない
      this.$store.commit('Timeline/setType', 0)
      // entries を空にしないと Timeline.fetchData() が呼ばれない
      this.$store.commit('Timeline/clearEntries')
      this.$store.commit('TimelineUser/setName', this.profile['name'])
      this.$store.commit('TimelineUser/setUserId', this.currentId)
      this.$router.push({
        name: 'timeline/user',
        params: {
          user_id: this.currentId,
          name: this.profile['name']
        }
      })
    },

    /**
     * タイムライン詳細にアクセス
     */
    async jupToTimelineDetail(tweet: any, index: number) {
      // Timeline/entries[index] のデータを更新しないと違うデータが表示されてしまう
      this.$store.commit('Timeline/setEntry', {
        entry: tweet,
        index: index
      })
      // Timeline/entries の何番目の要素にアクセスしているかを更新
      this.$store.commit('Timeline/setCurrentEntryKey', index)
      this.$store.commit('TimelineDetail/setCurrentData', tweet)
      this.$store.commit('TimelineUser/setName', this.profile['name'])
      this.$store.commit('TimelineUser/setUserId', this.currentId)
      this.$router.push(`/timeline/${this.currentId}/${tweet.t_id}`)
    },

    /**
     * 前のユーザを表示する
     */
    async handlePrevUserClick() {
      if (this.disabledPrevUserButton || this.isRefreshing) {
        return
      }
      this.disabledNextUserButton = false

      if (this.isTopGridStyle) {
        if (this.currentKeys[0] === 0 && this.currentKeys[1] === 0) {
          this.disabledPrevUserButton = true
        } else {
          if (this.currentKeys[1] === 0) {
            // 前の行へ
            this.currentKeys[0] -= 1
            this.currentKeys[1] = 1
          } else {
            this.currentKeys[1] -= 1
          }

          const ret = await this.refreshCurrentUserData()
          if (!ret) {
            // 前のユーザが存在しなかったなら再帰呼出し
            this.handlePrevUserClick()
          }
          if (this.currentKeys[0] === 0 && this.currentKeys[1] === 0) {
            this.disabledPrevUserButton = true
          }
        }
      } else {
        if (this.currentKey === 0) {
          this.disabledPrevUserButton = true
        } else {
          this.currentKey--
          const ret = await this.refreshCurrentUserData()
          if (!ret) {
            // 前のユーザが存在しなかったなら再帰呼出し
            this.handlePrevUserClick()
          }
          if (this.currentKey === 0) {
            this.disabledPrevUserButton = true
          }
        }
      }
    },

    /**
     * 次のユーザを表示する
     */
    async handleNextUserClick() {
      if (this.disabledNextUserButton || this.isRefreshing) {
        return
      }
      this.disabledPrevUserButton = false

      if (this.isTopGridStyle) {
        if (this.currentKeys[0] >= this.keys.length && this.currentKeys[1] === 1) {
          this.disabledNextUserButton = true
        } else {
          if (this.currentKeys[1] === 1) {
            // 次の行へ
            this.currentKeys[0] += 1
            this.currentKeys[1] = 0
          } else {
            this.currentKeys[1] += 1
          }

          const ret = await this.refreshCurrentUserData()
          if (!ret) {
            // 次のユーザが存在しなかったなら再帰呼出し
            this.handleNextUserClick()
          }
          if (this.currentKeys[0] === this.keys.length - 1 && this.currentKeys[1] === 1) {
            this.disabledNextUserButton = true
          } else if (this.keys.length - 1 - this.currentKeys[0] <= 5 && this.currentKeys[1] === 0) {
            // 残りが5件以下 && grid の1つ目の要素なら infinite を実行する
            this.infiniteEntries()
          }
        }
      } else {
        if (this.currentKey >= this.keys.length) {
          this.disabledNextUserButton = true
        } else {
          this.currentKey++
          const ret = await this.refreshCurrentUserData()
          if (!ret) {
            // 次のユーザが存在しなかったなら再帰呼出し
            this.handleNextUserClick()
          }
          if (this.currentKey === this.keys.length - 1) {
            this.disabledNextUserButton = true
          } else if (this.keys.length - 1 - this.currentKey <= 5) {
            // 残りが5件以下なら infinite を実行する
            this.infiniteEntries()
          }
        }
      }
    },

    /**
     * 現在表示中のユーザデータをリフレッシュする
     */
    async refreshCurrentUserData(this: any): Promise<boolean> {
      this.isRefreshing = true
      let entry = null

      const index = this.isTopGridStyle ? this.currentKeys[0] : this.currentKey
      const len = this.isTopGridStyle ? this.gridEntries.length : this.entries.length
      if (index > len) {
        this.isRefreshing = false
        return true
      }

      if (this.isTopGridStyle) {
        entry = this.gridEntries[this.currentKeys[0]][this.currentKeys[1]]
        if (!entry) {
          this.isRefreshing = false
          return true
        }
        this.currentId = entry.id
        // ブロックしたときにリアルタイムで反映されるように currentKey を更新
        this.$store.commit(
          `${this.$store.getters.fromStoreModuleName}/setCurrentEntryKeys`,
          this.currentKeys
        )
        this.profile = entry.profile
      } else {
        entry = this.entries[this.currentKey]
        if (!entry) {
          this.isRefreshing = false
          return true
        }
        this.currentId = entry.id
        // ブロックしたときにリアルタイムで反映されるように currentKey を更新
        this.$store.commit(
          `${this.$store.getters.fromStoreModuleName}/setCurrentEntryKey`,
          this.currentKey
        )
        this.profile = entry.profile
      }

      if (!this.currentId) {
        // お気に入り解除などによりユーザが一覧から削除されている
        this.isRefreshing = false
        return false
      }

      history.replaceState('user_replace', null, '#/user/' + this.currentId)
      const data = await this.$_fetchProfile(this.currentId)
      data.id = this.currentId
      const fetchProf = data.profile
      this.profile = fetchProf
      this.tweets = data.tweets
      this.setCurrentData(data)

      if (this.isTopGridStyle) {
        const entry = _.cloneDeep(this.gridEntries[this.currentKeys[0]][this.currentKeys[1]])
        entry.profile = this.profile
        this.setGridEntry({
          entry: entry,
          index1: this.currentKeys[0],
          index2: this.currentKeys[1]
        })
      } else if (this.currentKey) {
        const entry = _.cloneDeep(this.entries[this.currentKey])
        entry.profile = this.profile
        this.setEntry({
          entry: entry,
          index: this.currentKey
        })
      }

      this.isRefreshing = false
      return true
    },

    /**
     * Home.vue の infinite と同じことをする
     */
    async infiniteEntries(this: any) {
      if (!this.$store.getters['TopUser/enabledInfinite']) {
        return
      }
      let payload = { params: null }
      if (this.$route.params.fetchPayload) {
        payload = this.$route.params.fetchPayload
      } else if (this.props && this.props.fetchPayload) {
        payload = this.props.fetchPayload
      }
      await this.$store.dispatch('TopUser/infinite', {
        fetchPayload: payload
      })
      if (this.isTopGridStyle) {
        this.keys = Object.keys(this.gridEntries)
      } else {
        this.keys = Object.keys(this.entries)
      }
    },

    /**
     * ナビバーの左ボタンクリック
     */
    handleBackClick() {
      if (this.overlayPageModal) {
        history.back()
      } else {
        this.$router.back()
      }
    },

    /**
     * リフレッシュ
     */
    onRefresh() {
      this.fetchData()
    },

    /**
     * プロフ画像のクリック
     */
    handleClickProfImage() {
      this.$_showMediaModal({
        mediaUrl: this.profile['image_url_l'],
        mediaType: 'photo',
        savePhotoPoint: this.savePhotoPoint,
        requestUrl: '/user_profile/',
        requestParams: { id: this.currentId }
      })
    }
  }
})
